import { render, staticRenderFns } from "./OrderAlarm.vue?vue&type=template&id=f0da8652&scoped=true&"
import script from "./OrderAlarm.vue?vue&type=script&lang=js&"
export * from "./OrderAlarm.vue?vue&type=script&lang=js&"
import style0 from "./OrderAlarm.vue?vue&type=style&index=0&id=f0da8652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0da8652",
  null
  
)

export default component.exports